import { BufferWriter, Writer } from "protobufjs";

import { MessageRoom } from "../../../domain/model/message_room";
import { IMessageRoomRepository } from "../../../domain/repository/message_room_repository";

import { IApiClient } from "../client";
import { api, common, entity } from "../rpc/api";
import { getToken } from "./bind_token";

import MessageRoomList = entity.MessageRoomList;
import GetMessageRoomRequest = api.GetMessageRoomRequest;
import ReadMessageRoomRequest = api.ReadMessageRoomRequest;
import CreateMessageRoomRequest = api.CreateMessageRoomRequest;
import DeleteMessageRoomRequest = api.DeleteMessageRoomRequest;

import Pager = common.Pager;

import {
  MessageRoomConvertResponse,
  MessageRoomConvertResponseList,
} from "./message_room_api_convert";

class MessageRoomAPI implements IMessageRoomRepository {
  constructor(readonly apiClient: IApiClient) {}

  public getAllByCustomer(
    page: number,
    offset: number
  ): Promise<MessageRoom[]> {
    return new Promise<MessageRoom[]>((resolve, reject) => {
      getToken()
        .then((token: string): Promise<Uint8Array> => {
          const req: Pager = new Pager();
          req.page = page;
          req.offset = offset;
          const writer: BufferWriter | Writer = Writer.create();
          return this.apiClient.postWithToken(
            "/api.MessageRoomService/GetAll",
            token,
            Pager.encode(req, writer).finish()
          );
        })
        .then((binary: Uint8Array): void => {
          const res: MessageRoomList = MessageRoomList.decode(binary);
          // BE=>FE 型変換
          const resConverted: MessageRoomConvertResponseList =
            MessageRoomConvertResponseList.from(res);
          const items: MessageRoom[] = resConverted.items.map(
            (item: MessageRoomConvertResponse): MessageRoom => {
              return MessageRoom.from(item);
            }
          );
          resolve(items);
        })
        .catch((error: Error): void => {
          reject(error);
        });
    });
  }

  public getAllByClient(page: number, offset: number): Promise<MessageRoom[]> {
    return new Promise<MessageRoom[]>((resolve, reject) => {
      getToken()
        .then((token: string): Promise<Uint8Array> => {
          const req: Pager = new Pager();
          req.page = page;
          req.offset = offset;
          const writer: BufferWriter | Writer = Writer.create();
          return this.apiClient.postWithToken(
            "/api.MessageRoomService/GetAll",
            token,
            Pager.encode(req, writer).finish()
          );
        })
        .then((binary: Uint8Array): void => {
          const res: MessageRoomList = MessageRoomList.decode(binary);
          // BE=>FE 型変換
          const resConverted: MessageRoomConvertResponseList =
            MessageRoomConvertResponseList.from(res);
          const items: MessageRoom[] = resConverted.items.map(
            (item: MessageRoomConvertResponse): MessageRoom => {
              return MessageRoom.from(item);
            }
          );
          resolve(items);
        })
        .catch((error: Error): void => {
          reject(error);
        });
    });
  }

  public get(projectID: string, opponentID: string): Promise<MessageRoom> {
    return new Promise<MessageRoom>((resolve, reject) => {
      getToken()
        .then((token: string): Promise<Uint8Array> => {
          const req: GetMessageRoomRequest = new GetMessageRoomRequest();
          req.projectID = projectID;
          req.opponentID = opponentID;
          const writer: BufferWriter | Writer = Writer.create();
          return this.apiClient.postWithToken(
            "/api.MessageRoomService/Get",
            token,
            GetMessageRoomRequest.encode(req, writer).finish()
          );
        })
        .then((binary: Uint8Array): void => {
          const res: entity.MessageRoom = entity.MessageRoom.decode(binary);
          // BE=>FE 型変換
          const resConverted: MessageRoomConvertResponse =
            MessageRoomConvertResponse.from(res);
          const item: MessageRoom = MessageRoom.from(resConverted);
          resolve(item);
        })
        .catch((error: Error): void => {
          reject(error);
        });
    });
  }

  public read(projectID: string, opponentID: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      getToken()
        .then((token: string): Promise<Uint8Array> => {
          const req: ReadMessageRoomRequest = new ReadMessageRoomRequest();
          req.projectID = projectID;
          req.opponentID = opponentID;
          const writer: BufferWriter | Writer = Writer.create();
          return this.apiClient.postWithToken(
            "/api.MessageRoomService/Read",
            token,
            ReadMessageRoomRequest.encode(req, writer).finish()
          );
        })
        .then((binary: Uint8Array): void => {
          resolve();
        })
        .catch((error: Error): void => {
          reject(error);
        });
    });
  }

  public create(projectID: string, opponentID: string): Promise<MessageRoom> {
    return new Promise<MessageRoom>((resolve, reject) => {
      getToken()
        .then((token: string): Promise<Uint8Array> => {
          const req: CreateMessageRoomRequest = new CreateMessageRoomRequest();
          req.projectID = projectID;
          req.opponentID = opponentID;
          const writer: BufferWriter | Writer = Writer.create();
          return this.apiClient.postWithToken(
            "/api.MessageRoomService/Create",
            token,
            CreateMessageRoomRequest.encode(req, writer).finish()
          );
        })
        .then((binary: Uint8Array): void => {
          const res: entity.MessageRoom = entity.MessageRoom.decode(binary);
          // BE=>FE 型変換
          const resConverted: MessageRoomConvertResponse =
            MessageRoomConvertResponse.from(res);
          const item: MessageRoom = MessageRoom.from(resConverted);
          resolve(item);
        })
        .catch((error: Error): void => {
          reject(error);
        });
    });
  }

  public delete(projectID: string, opponentID: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      getToken()
        .then((token: string): Promise<Uint8Array> => {
          const req: DeleteMessageRoomRequest = new DeleteMessageRoomRequest();
          req.projectID = projectID;
          req.opponentID = opponentID;
          const writer: BufferWriter | Writer = Writer.create();
          return this.apiClient.postWithToken(
            "/api.MessageRoomService/Delete",
            token,
            DeleteMessageRoomRequest.encode(req, writer).finish()
          );
        })
        .then((binary: Uint8Array): void => {
          resolve();
        })
        .catch((error: Error): void => {
          reject(error);
        });
    });
  }
}

const createMessageRoomAPI = (
  apiClient: IApiClient
): IMessageRoomRepository => {
  return new MessageRoomAPI(apiClient);
};

export { createMessageRoomAPI };



// WEBPACK FOOTER //
// ./src/infra/api/service/message_room_api.ts